module.exports = __webpack_public_path__ + "img/Lucy Burrows.37248809.png";